import React from 'react'
import * as immutable from 'immutable'
import { toMoney } from '@mobi/utils/money'
import { BetslipItem } from '@core/Areas/Betslip/driver'
import { calculateMultiReturn } from '@core/Areas/Betslip/helpers/calculator'
import { AnimatedNumberTransition } from '@mobi/component-library/Common/AnimatedNumberTransition'
import {
  MultiToastPriceContainerStyled,
  MultiToastPriceTitleStyled,
  MultiToastPriceAmountStyled,
} from './MultiToastPrice.styles'

export function MultiToastPrice({ betslipItems }: { betslipItems: BetslipItem[] }) {
  const price = calculateMultiReturn(immutable.List(betslipItems), { shouldRound: true })

  return (
    <MultiToastPriceContainerStyled>
      <MultiToastPriceTitleStyled>Multi</MultiToastPriceTitleStyled>
      <MultiToastPriceAmountStyled>
        <AnimatedNumberTransition start='$0.00' end={toMoney(price)} separatorCharacters='$' />
      </MultiToastPriceAmountStyled>
    </MultiToastPriceContainerStyled>
  )
}
